import React, { useCallback, useEffect, useMemo } from 'react'
import { Button, Popconfirm } from 'antd'
import { isEmpty, size } from 'lodash'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../../core/helpers'

import { useDeletePriorityTaskAllocationMutation } from '../../hooks'

const PriorityTaskBulkRemoveAllocationsButton = ({
  selectedAllocationIds,
  onSelectionChange,
}) => {
  const [deleteAllocation, { error, isLoading }] =
    useDeletePriorityTaskAllocationMutation()

  const handleBulkRemove = useCallback(() => {
    deleteAllocation(selectedAllocationIds)
    onSelectionChange([])
  }, [deleteAllocation, selectedAllocationIds, onSelectionChange])

  const isDisabled = useMemo(
    () => isEmpty(selectedAllocationIds),
    [selectedAllocationIds],
  )

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Failed to delete allocation',
        description: error,
      })
    }
  }, [error])

  return (
    <div style={{ textAlign: 'right', paddingBottom: '16px' }}>
      <Popconfirm
        title={`This action is irreversible. Are you sure you want to remove ${selectedAllocationIds.length} allocation(s)?`}
        onConfirm={handleBulkRemove}
        disabled={isDisabled}
      >
        <Button type="primary" danger disabled={isDisabled} loading={isLoading}>
          Remove {size(selectedAllocationIds)} allocation(s)
        </Button>
      </Popconfirm>
    </div>
  )
}

PriorityTaskBulkRemoveAllocationsButton.propTypes = {
  selectedAllocationIds: PropTypes.array.isRequired,
  onSelectionChange: PropTypes.func.isRequired,
}

export default PriorityTaskBulkRemoveAllocationsButton
